module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/partners-07-0cd024059bd8f6be5698789bdd65e46a.png";